import { prodOrDevCdnParam } from './isEnv'

const statusMap = {
  right_now: 'looking',
  meetup: 'handshake',
  chatting: 'chat',
  romance: 'heart',
}

const tempStatusMetaMaps = {
  position: {
    top: 'arrow-up',
    bottom: 'arrow-down',
    verse: 'arrows-down-up',
    side: 'arrows-horizontal',
  },
  hosting: {
    hosting: 'house',
    traveling: 'car',
    host_or_travel: 'host_or_travel',
  }
}

const tempStatusIconSrc = (tempStatus) => (
  tempStatus
    ? `https://mandrake-app.b-cdn.net/${prodOrDevCdnParam()}/application/icons/${statusMap[tempStatus]}.png`
    : ''
)

const metaIconSrc = (accessor, value) => (
  (accessor && value)
    ? `https://mandrake-app.b-cdn.net/${prodOrDevCdnParam()}/application/icons/${tempStatusMetaMaps[accessor][value]}.svg`
    : ''
)

export { statusMap, tempStatusMetaMaps, tempStatusIconSrc, metaIconSrc }
